import { IFormTypeService } from "../../service/formconfiguration/FormTypeService";

export default class GetFormTypesInteractor {
  private formTypeService: IFormTypeService;

  constructor(formTypeService) {
    this.formTypeService = formTypeService;
  }

  async execute(status?: string) {
    return this.formTypeService.getFormTypes(status);
  }
}
